export const environment = {
	production: true,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	ApiRoot: 'https://nfc-api.jeeerp.com/api',
	pageSize: [5, 10, 20, 50, 100],
	//Redirect Url test
	redirectUrl: [
		'https://nfc-scbt.bookve.com.vn',
	],
	//Api-DEV
	//ApiRoot:'https://nfc-apidev.bookve.com.vn/api'

	//Api-TEST
	//ApiRoot:'https://nfc-apicore.bookve.com.vn/api'

	//Api-LIVE
	//ApiRoot:'https://nfc-api.jeeerp.com/api'
};
